import { clearAuthUser } from "../../reducers/authUserSlice";

const DEFAULT_MESSAGE = "Din session har gått ut. Vänligen logga in igen.";
const LOGIN_URL = "/login";

export function handleExpiredSession(
  dispatch,
  navigate,
  message = DEFAULT_MESSAGE,
) {
  localStorage.clear();
  sessionStorage.clear();
  dispatch(clearAuthUser());
  alert(message);
  navigate(LOGIN_URL);
}
